import * as ambassadorWixSocialGroupsV2MembershipQuestion from './social-groups-v2-membership-question-membership-questions.http.js';
import * as ambassadorWixSocialGroupsV2MembershipQuestionTypes from './social-groups-v2-membership-question-membership-questions.types.js';
import * as ambassadorWixSocialGroupsV2MembershipQuestionUniversalTypes from './social-groups-v2-membership-question-membership-questions.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listMembershipQuestions(): __PublicMethodMetaInfo<
  'GET',
  { groupId: string },
  ambassadorWixSocialGroupsV2MembershipQuestionUniversalTypes.ListMembershipQuestionsRequest,
  ambassadorWixSocialGroupsV2MembershipQuestionTypes.ListMembershipQuestionsRequest,
  ambassadorWixSocialGroupsV2MembershipQuestionUniversalTypes.ListMembershipQuestionsResponse,
  ambassadorWixSocialGroupsV2MembershipQuestionTypes.ListMembershipQuestionsResponse
> {
  const payload = { groupId: ':groupId' } as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2MembershipQuestion.listMembershipQuestions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/membership-questions/{groupId}',
    pathParams: { groupId: 'groupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createOrReplaceAllMembershipQuestions(): __PublicMethodMetaInfo<
  'PUT',
  { groupId: string },
  ambassadorWixSocialGroupsV2MembershipQuestionUniversalTypes.CreateOrReplaceAllMembershipQuestionsRequest,
  ambassadorWixSocialGroupsV2MembershipQuestionTypes.CreateOrReplaceAllMembershipQuestionsRequest,
  ambassadorWixSocialGroupsV2MembershipQuestionUniversalTypes.CreateOrReplaceAllMembershipQuestionsResponse,
  ambassadorWixSocialGroupsV2MembershipQuestionTypes.CreateOrReplaceAllMembershipQuestionsResponse
> {
  const payload = { groupId: ':groupId' } as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2MembershipQuestion.createOrReplaceAllMembershipQuestions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PUT',
    path: '/v2/membership-questions/{groupId}',
    pathParams: { groupId: 'groupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listAnswers(): __PublicMethodMetaInfo<
  'POST',
  { groupId: string },
  ambassadorWixSocialGroupsV2MembershipQuestionUniversalTypes.ListAnswersRequest,
  ambassadorWixSocialGroupsV2MembershipQuestionTypes.ListAnswersRequest,
  ambassadorWixSocialGroupsV2MembershipQuestionUniversalTypes.ListAnswersResponse,
  ambassadorWixSocialGroupsV2MembershipQuestionTypes.ListAnswersResponse
> {
  const payload = { groupId: ':groupId' } as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2MembershipQuestion.listAnswers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/membership-questions/{groupId}/answers',
    pathParams: { groupId: 'groupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  MembershipQuestion as MembershipQuestionOriginal,
  ListMembershipQuestionsRequest as ListMembershipQuestionsRequestOriginal,
  ListMembershipQuestionsResponse as ListMembershipQuestionsResponseOriginal,
  CreateOrReplaceAllMembershipQuestionsRequest as CreateOrReplaceAllMembershipQuestionsRequestOriginal,
  CreateOrReplaceAllMembershipQuestionsResponse as CreateOrReplaceAllMembershipQuestionsResponseOriginal,
  ListAnswersRequest as ListAnswersRequestOriginal,
  Paging as PagingOriginal,
  ListAnswersResponse as ListAnswersResponseOriginal,
  MemberMembershipQuestionAnswers as MemberMembershipQuestionAnswersOriginal,
  MembershipQuestionAnswer as MembershipQuestionAnswerOriginal,
  PagingMetadata as PagingMetadataOriginal,
  ListAnswerCountsRequest as ListAnswerCountsRequestOriginal,
  ListAnswerCountsResponse as ListAnswerCountsResponseOriginal,
  MemberAnswerCount as MemberAnswerCountOriginal,
} from './social-groups-v2-membership-question-membership-questions.types.js';
